import { ApolloError } from "@apollo/client";

export const hasGraphQLErrorCode = (error: unknown, code: string): boolean => {
  return (
    error instanceof ApolloError &&
    error.graphQLErrors.some(({ extensions }) => extensions?.code === code)
  );
};
